/* eslint-disable jsx-a11y/label-has-associated-control */
import { useAtom } from 'jotai';
import { MdClose, MdFlag } from 'react-icons/md';
import {
  isFeatureFlagPanelOpenAtom,
  featureFlagAtoms,
} from '../../store/flags';

function FeatureFlagToggle({ atom, label }: { atom: any; label: string }) {
  const [flag, setFlag] = useAtom(atom);

  return (
    <label className='flex items-center justify-between gap-4 py-1 cursor-pointer select-none'>
      <span className='text-gray-700 font-medium'>{label}</span>
      <div
        className={`group relative inline-flex w-11 shrink-0 rounded-full p-0.5
        transition-colors duration-200 ease-in-out
        ${flag ? 'bg-blue-600' : 'bg-gray-200'}
        outline-offset-2 outline-blue-600`}
      >
        <span
          className={`size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5
            transition-transform duration-200 ease-in-out
            ${flag ? 'translate-x-5' : ''}
          `}
        />
        <input
          type='checkbox'
          checked={!!flag}
          aria-label={label}
          className='absolute inset-0 opacity-0 cursor-pointer'
          onChange={() => setFlag((v: any) => !v)}
        />
      </div>
    </label>
  );
}

export function FeatureFlagPanel() {
  const [isOpen, setIsOpen] = useAtom(isFeatureFlagPanelOpenAtom);

  return (
    <>
      {!isOpen && (
        <button
          type='button'
          className='fixed bottom-2 right-2 z-50 bg-blue-600 text-white rounded-full shadow-lg p-3 hover:bg-blue-700 transition'
          onClick={() => setIsOpen(true)}
          aria-label='Open feature flag panel'
        >
          <MdFlag size={24} />
        </button>
      )}
      {isOpen && (
        <div className='fixed bottom-2 right-2 z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-4 w-80'>
          <div className='flex items-center justify-between mb-2'>
            <span className='font-bold text-gray-700 text-lg'>
              Feature Flags
            </span>
            <button
              type='button'
              className='text-gray-400 hover:text-gray-700 transition text-xl'
              onClick={() => setIsOpen(false)}
              aria-label='Close feature flag panel'
            >
              <MdClose size={24} />
            </button>
          </div>
          <div className='flex flex-col gap-3 mt-2'>
            {Object.entries(featureFlagAtoms).map(([key, atom]) => {
              const label = key
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, (str) => str.toUpperCase());
              return <FeatureFlagToggle key={key} atom={atom} label={label} />;
            })}
          </div>
        </div>
      )}
    </>
  );
}
